var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4C5F7E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29C17.7 29 15.6958 28.2375 13.9875 26.7125C12.2792 25.1875 11.3 23.2833 11.05 21H13.1C13.3333 22.7333 14.1042 24.1667 15.4125 25.3C16.7208 26.4333 18.25 27 20 27C21.95 27 23.6042 26.3208 24.9625 24.9625C26.3208 23.6042 27 21.95 27 20C27 18.05 26.3208 16.3958 24.9625 15.0375C23.6042 13.6792 21.95 13 20 13C18.85 13 17.775 13.2667 16.775 13.8C15.775 14.3333 14.9333 15.0667 14.25 16H17V18H11V12H13V14.35C13.85 13.2833 14.8875 12.4583 16.1125 11.875C17.3375 11.2917 18.6333 11 20 11C21.25 11 22.4208 11.2375 23.5125 11.7125C24.6042 12.1875 25.5542 12.8292 26.3625 13.6375C27.1708 14.4458 27.8125 15.3958 28.2875 16.4875C28.7625 17.5792 29 18.75 29 20C29 21.25 28.7625 22.4208 28.2875 23.5125C27.8125 24.6042 27.1708 25.5542 26.3625 26.3625C25.5542 27.1708 24.6042 27.8125 23.5125 28.2875C22.4208 28.7625 21.25 29 20 29ZM22.8 24.2L19 20.4V15H21V19.6L24.2 22.8L22.8 24.2Z",
    fill: "#004AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic-history.a9d4c0038517f50a681a06b0572b3a3c.svg";
export { ForwardRef as ReactComponent };